import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 9 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 16\" id=\"icon-left\">\r\n  <path d=\"M7,0,0,7l7,7\" transform=\"translate(1 1)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol